import React from 'react'

export default function Manufacturing() {
  return (
    <div>Manufacturing</div>
  )
}
